import {GET_SRT_STATS, GET_SRT_STATUS} from '../constants/actionTypes';
import objectAssign from 'object-assign';
import initialState from './initialState';

// IMPORTANT: Note that with Redux, state should NEVER be changed.
// State is considered immutable. Instead,
// create a copy of the state passed and set new values on the copy.
// Note that I'm using Object.assign to create a copy of current state
// and update values on the copy.
export default function srtStatsReducer(state = initialState.srtStats, action) {
  let newState;
  switch (action.type) {
    case GET_SRT_STATS:
      if(action.key == "subscribeToStats"){
        newState = objectAssign({}, initialState.srtStats, {containerId: action.payload.containerId});
      } else {
        let data = {
          sid: action.payload.sid,
          time: action.payload.time,
          peerIP: action.payload.peerIP,
          recv: action.payload.recv,
          link: action.payload.link,
          window: action.payload.window,
          send: action.payload.send
       };
       if(action.payload.direction == "out") {
        newState = objectAssign({}, state, {containerId: action.payload.containerId, output: data});
       } else {
        newState = objectAssign({}, state, {containerId: action.payload.containerId, input: data});
       }
       
      }
      return newState;

    case GET_SRT_STATUS:
      //return state;
      let defaultStatus = { connected: false, dropped: false, lost: false };
      let containerStatus = {};
      if(action.payload.direction == "out") {
        containerStatus = state.containerStatusOutput ? state.containerStatusOutput : {};
      } else {
        containerStatus = state.containerStatusInput ? state.containerStatusInput : {};
      }
      let connected = false;
      let dropped = false;
      let lost = false;
      if(containerStatus[action.payload.containerId] !== undefined) {
        connected = containerStatus[action.payload.containerId].connected || false;
        dropped = containerStatus[action.payload.containerId].dropped || false;
        lost = containerStatus[action.payload.containerId].lost || false;
      }
      let statusData = {
        connected: typeof action.payload.connected == 'undefined' ? connected : (action.payload.connected == 1),
        dropped: typeof action.payload.dropped == 'undefined' ? dropped : action.payload.dropped,
        lost: typeof action.payload.lost == 'undefined' ? lost : action.payload.lost
      };
      containerStatus[action.payload.containerId] = statusData;
      if(action.payload.direction == "out") {
        newState = objectAssign({}, state, {containerStatusOutput: containerStatus})
      } else {
        newState = objectAssign({}, state, {containerStatusInput: containerStatus})
      }
      
      return newState;

    default:
      return state;
  }
}
